import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProfilePage from '~/profile-page';
import {
  profilePages,
  profileTabPages,
  profileChildTabPages,
  getProfilesParams,
  generic,
  isServiceRoute,
  DEFAULT_TAB_ID,
} from '~/routes';

const ProfilePages = ({ profiles, location, profileRouteLoaded }) => {
  const { pathname } = location;
  const params = getProfilesParams({
    pathname,
  });
  let profile = null;
  const serviceRouteParams = isServiceRoute({ pathname });
  let { tabId } = params;
  if (serviceRouteParams?.service) {
    profile =
      profiles &&
      [...profiles].find((p) => p.service === serviceRouteParams.service);
    tabId = DEFAULT_TAB_ID;
  } else {
    const { profileId } = params;

    profile =
      profileId && profiles && [...profiles].find((p) => p.id === profileId);
  }

  useEffect(() => {
    if (profile) {
      profileRouteLoaded({ profile, tabId });
    }
  }, []);

  return (
    <Switch>
      {profile && (
        <Route path={profileChildTabPages.route} component={ProfilePage} />
      )}
      {profile && (
        <Route path={profileTabPages.route} component={ProfilePage} />
      )}
      {profile && serviceRouteParams && (
        <Redirect
          to={profileTabPages.getRoute({
            profileId: profile.id,
            tabId,
          })}
        />
      )}
      {profile && (
        <Redirect from={profilePages.route} to={profileTabPages.defaultRoute} />
      )}
      <Redirect to={generic.route} />
    </Switch>
  );
};

ProfilePages.propTypes = {
  profiles: PropTypes.arrayOf(PropTypes.object).isRequired,
  location: PropTypes.objectOf(PropTypes.string).isRequired,
  profileRouteLoaded: PropTypes.func.isRequired,
};

export default ProfilePages;
